import React, { Component, Fragment } from 'react';
import {
  required, LongTextInput,
  SelectInput,
  SimpleForm,
  TextInput,
  translate,
  FormDataConsumer
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { ReactMic } from '@cleandersonlobo/react-mic';
import WaveSurfer from 'wavesurfer.js';
import Regions from "../../node_modules/wavesurfer.js/dist/plugin/wavesurfer.regions.js";
import Timeline from "../../node_modules/wavesurfer.js/dist/plugin/wavesurfer.timeline.js";
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import MicIcon from '@material-ui/icons/Mic';
import StopIcon from '@material-ui/icons/Stop';
import CloudUpload from '@material-ui/icons/CloudUpload';
import CancelUpload from '@material-ui/icons/Cancel';
import ClearAll from '@material-ui/icons/ClearAll';
import { configAPI } from '../config'
import FileUpload from '@material-ui/icons/CloudUpload';
import { Tooltip } from '@material-ui/core';
import { push as pushAction } from 'react-router-redux';
import { refreshView as refreshViewAction } from 'ra-core';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField'
import axios from 'axios';
import { encodeDecode } from '../myutils';
import FineUploaderTraditional from 'fine-uploader-wrappers'
import Gallery from 'react-fine-uploader'
import 'react-fine-uploader/gallery/gallery.css'

var uploader = new FineUploaderTraditional({
  options: {
    maxConnections: 1,
    maxSize: 30,
    autoUpload: false,
    deleteFile: {
      enabled: false
    },
    chunking: {
      enabled: true,
      partSize: 4000000,
      success: {
        endpoint: configAPI.api.prod + '/UploadFile?done'
      }
    },
    request: {
      endpoint: configAPI.api.prod + '/UploadFile'
    },
    retry: {
      enableAuto: true
    },
  },
  callbacks: {
  }
})

export const TemplateIcon = BookIcon;

class UploadFile extends Component {

  constructor(props) {
    super(props);
    const CancelToken = axios.CancelToken;

    this.state = {
      showUploadButton: false,
      showCancelUploadButton: false,
      record: false,
      pause: false,
      openDialog: false,
      startUpload: false,
      autoNumbering: true,
      blobURL: '',
      recordingUploadProgress: 0,
      totalUploaded: 0,
      totalUploadedProgress: 0,
      messageType: sessionStorage.getItem('messageType'),
      filePath: '',
      fullPath: '',
      fileName: '',
      acceptedFiles: [],
      filelist: [],
      deleteArray: [],
      resetUploader: false,
      source: CancelToken.source(),
      showCrop:false,
      showWave:false
    }
  }


  startRecording = (e) => {
    e.stopPropagation();
    this.setState({
      record: true,
      recordingUploadProgress: 0,
      showWave:true
    });
  }

  stopRecording = (e) => {
    e.stopPropagation();
    this.setState({
      record: false,
    });
  }

  onData(recordedBlob) {
    // console.log(recordedBlob)
  }

  onStop = (recordedBlob) => {
    this.setState({
      showUploadButton: true,
      showCancelUploadButton: false,
      newRecording: recordedBlob.blob,
      blobURL: recordedBlob.blobURL,
      bytesPerSecond: recordedBlob.options.audioBitsPerSecond,
      recordingLength: recordedBlob.stopTime - recordedBlob.startTime,
      blobSize: recordedBlob.blob.size,
      showWave:true
    })

    var wavesurfer = WaveSurfer.create({
      mediaControls: true,
      container: '#waveform',
      waveColor: '#adcbec',
      progressColor: '#007aff',
      backend: 'MediaElement',
    });
    var blob = recordedBlob.blob;
    var blobUrl = recordedBlob.blobURL;
    var me = this;
    createSurfer(blob, blobUrl, wavesurfer, me);

    function createSurfer (blob, blobUrl, wavesurfer, me) {

      // wavesurfer.regions.clearRegions();
      wavesurfer.destroy();
      
      var regionsPlugins = Regions.create({
        regions: [],
        dragSelection: {
          slop: 5
        }
      });
  
      var timelinePlugins = Timeline.create({
        container: '#timeline',
        formatTimeCallback: formatTimeCallback,
        timeInterval: timeInterval,
        primaryLabelInterval: primaryLabelInterval,
        secondaryLabelInterval: secondaryLabelInterval,
        primaryColor: 'blue',
        secondaryColor: 'red',
        primaryFontColor: 'blue',
        secondaryFontColor: 'red'
      });
  
      var wavesurfer = WaveSurfer.create({
        mediaControls: true,
        container: '#waveform',
        waveColor: '#adcbec',
        progressColor: '#007aff',
          backend: 'MediaElement',
        plugins: [
          regionsPlugins,
          timelinePlugins
        ]
      });
  
      wavesurfer.on('region-created', region => {
        wavesurfer.regions.clear();
        me.setState({showCrop:true})
      });
  
      wavesurfer.on('region-contextmenu', function (e) {
        console.log(e);
      })

      wavesurfer.on('error', function (e) {
        console.warn(e);
      });  

      // Zoom slider
      let slider = document.querySelector('[data-action="zoom"]');
      slider.value = wavesurfer.params.minPxPerSec;
      slider.min = wavesurfer.params.minPxPerSec;
      slider.addEventListener('input', function () {
        wavesurfer.zoom(Number(this.value));
      });

      document.querySelector(
        '[data-action="play-region"]'
      ).addEventListener('click', function () {
        let region = Object.values(wavesurfer.regions.list)[0];
        region.play();
      });

      var croper = document.querySelector('[data-action="crop"]');
      var self = me;
      croper.addEventListener("click", () => {
        var list = Object.keys(wavesurfer.regions.list).map(key => wavesurfer.regions.list[key]);
        var region = list[0];
        var finalBlob = blob.slice(region.start * 8100, (region.end+0.25) * 8100, 'audio/ogg');
        self.setState({ newRecording: finalBlob });
        var objectURL = URL.createObjectURL(finalBlob)
        createSurfer(finalBlob, objectURL, wavesurfer, self);

      });
  
    
      wavesurfer.load(blobUrl);
      wavesurfer.play();
    }

    function formatTimeCallback(seconds, pxPerSec) {
      seconds = Number(seconds);
      let minutes = Math.floor(seconds / 60);
      seconds = seconds % 60;

      // fill up seconds with zeroes
      let secondsStr = Math.round(seconds).toString();
      if (pxPerSec >= 25 * 10) {
        secondsStr = seconds.toFixed(2);
      } else if (pxPerSec >= 25 * 1) {
        secondsStr = seconds.toFixed(1);
      }

      if (minutes > 0) {
        if (seconds < 10) {
          secondsStr = '0' + secondsStr;
        }
        return `${minutes}:${secondsStr}`;
      }
      return secondsStr;
    }

    function secondaryLabelInterval(pxPerSec) {
      // draw one every 10s as an example
      return Math.floor(10 / timeInterval(pxPerSec));
    }

    function timeInterval(pxPerSec) {
      let retval = 1;
      if (pxPerSec >= 25 * 100) {
        retval = 0.01;
      } else if (pxPerSec >= 25 * 40) {
        retval = 0.025;
      } else if (pxPerSec >= 25 * 10) {
        retval = 0.1;
      } else if (pxPerSec >= 25 * 4) {
        retval = 0.25;
      } else if (pxPerSec >= 25) {
        retval = 1;
      } else if (pxPerSec * 5 >= 25) {
        retval = 5;
      } else if (pxPerSec * 15 >= 25) {
        retval = 15;
      } else {
        retval = Math.ceil(0.5 / pxPerSec) * 60;
      }
      return retval;
    }

    function primaryLabelInterval(pxPerSec) {
      let retval = 1;
      if (pxPerSec >= 25 * 100) {
        retval = 10;
      } else if (pxPerSec >= 25 * 40) {
        retval = 4;
      } else if (pxPerSec >= 25 * 10) {
        retval = 10;
      } else if (pxPerSec >= 25 * 4) {
        retval = 4;
      } else if (pxPerSec >= 25) {
        retval = 1;
      } else if (pxPerSec * 5 >= 25) {
        retval = 5;
      } else if (pxPerSec * 15 >= 25) {
        retval = 15;
      } else {
        retval = Math.ceil(0.5 / pxPerSec) * 60;
      }
      return retval;
    }
  
  }



  handleClickOpen = (e) => {
    var what;
    var fileName = '';
    sessionStorage.setItem('files2upload', 0);
    e.stopPropagation();

    if (this.state.messageType === 'R' && !this.props.isMessage) this.setState({ autoNumbering: true });
    if (this.props.record.name!=undefined) this.setState({ autoNumbering: false, convertWav: false });
    if (this.props.record.path !== undefined) what = this.props.record.path + '/';
    else if (this.props.record.what !== undefined) {
      if (this.props.record.fileType === 'DIR') what = this.props.record.what + '/';
      else {
        what = this.props.record.what;
        what = what.substr(0, what.lastIndexOf("/") + 1);
        this.setState({ convertWav: false });
      }
    }
    else what = 'ivr2:/';
    what = ('/' + what.substr(what.indexOf(":") + 1)).replace('//', '/');
    if (this.props.record.name !== undefined) {
      if (this.props.record.fileType !== 'DIR') fileName = this.props.record.name;
    }
    this.setState({ openDialog: true, filePath: what, fullPath: what + fileName, fileName: fileName })
  };

  handleClose = (e) => {
    e.stopPropagation();
    if ((this.state.totalUploadedProgress >= 100) || (this.state.startUpload === false)) {
      this.setState({
        openDialog: false,
        showUploadButton: false,
        showCancelUploadButton: false,
        showNewUploadButton: false,
        totalUploadedProgress: 0,
        totalUploaded: 0,
        acceptedFiles: [],
        filelist: [],
        showCrop:false,
        showWave:false
      });
      const { refreshView } = this.props;
      refreshView();
    }
    else alert('העלאת קבצים מתבצעת, אנא המתן...');
  };

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value });
  };

  handleMessageTypeChange = (e) => {
    this.setState({ messageType: e[0] });
    sessionStorage.setItem('messageType', e[0]);
    var filePath = this.state.filePath
    var fileName = this.state.fileName.replace('.wav', '').replace('.tts', '').replace('.ini', '');
    if (e[0] === 'R' && !this.props.isMessage) this.setState({ autoNumbering: true });
    if (e[0] === 'R') this.setState({ fullPath: filePath + fileName + '.wav' });
    if (e[0] === 'I') this.setState({ fullPath: filePath + fileName + '.ini' });
    if (e[0] === 'T') this.setState({ fullPath: filePath + fileName + '.tts' });
    if (e[0] === 'U') this.setState({ fullPath: filePath + fileName });
  };

  handleTextFileNameChange = (e) => {
    let fileName = e.target.value;
    let filePath = '';
    filePath = this.state.filePath;
    if (this.state.messageType === 'I') this.setState({ fileName: fileName, fullPath: filePath + fileName + '.ini' });
    if (this.state.messageType === 'T') this.setState({ fileName: fileName, fullPath: filePath + fileName + '.tts' });
    if (this.state.messageType === 'R') this.setState({ fileName: fileName, fullPath: filePath + fileName + '.wav' });
    if (this.state.messageType === 'U') this.setState({ fileName: fileName, fullPath: filePath });
    if (fileName !== '') this.setState({ showUploadButton: true });
    else this.setState({ showUploadButton: false });
  };

  updateFileName = (e) => {
    var fileName = e.target.value;
    var index = e.target.name;
    var filelist = this.state.filelist;
    filelist[index] = fileName;
    this.setState({ filelist: filelist })
  };

  convertWav(autoNumbering) {
    this.setState({ autoNumbering: autoNumbering });
  }

  newUpload() {

    uploader.methods.reset();
    this.setState({ resetUploader: !this.resetUploader });
    this.setState({ showNewUploadButton: false, showUploadButton: false, acceptedFiles: [], totalUploadedProgress: 0, filelist: [] });
  }

  CancelUpload() {
    uploader.methods.cancelAll();
    this.state.source.cancel();
    const newCancelToken = axios.CancelToken;

    this.setState({ source: newCancelToken.source() })
    var filesUploaded = sessionStorage.getItem('filesUploaded');
    var files = this.state.acceptedFiles;
    files.splice(0, filesUploaded);
    this.setState({ acceptedFiles: files });
    this.setState({ showCancelUploadButton: false, startUpload: false });
    if (files.length > 0) {
      this.setState({ showUploadButton: true })
    }
    else {
      this.setState({ showNewUploadButton: true });
    }
  }

  handleSendSubmit = (e, approveDelete) => {
    if (e !== false) e.stopPropagation();
    const { message, fileName, messageType, acceptedFiles } = this.state;
    const { push, isMessage } = this.props;

    var what, uploadContents, config, self;


    switch (messageType) {
      case 'I': // create and save text file
      case 'T': // create and save text file
        if (!message) uploadContents = '%20';
        else uploadContents = message.replace(/(?:\r\n|\r|\n)/g, '%0A');

        if (fileName !== undefined || this.props.isMessage) {
          if (sessionStorage.AllFiles.indexOf('/' + fileName) > -1 && !this.state.autoNumbering) {
            if (window.confirm(' קיים קובץ עם שם זהה בתקיה. האם לדרוס את הקובץ ' + fileName)) {
              const ReqDelete = new Request(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=delete&what=ivr2:' + this.state.fullPath);
              fetch(ReqDelete)
                .then(response => response.json())
                .then(response => {
                  if (response.responseStatus === 'OK') {
                    const ReqUploadText = new Request(configAPI.api.prod + '/UploadTextFile?token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:' + this.state.fullPath + '&contents=' + uploadContents);
                    fetch(ReqUploadText);
                  }
                })
            }
          }
          else {
            const ReqUploadText = new Request(configAPI.api.prod + '/UploadTextFile?token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:' + this.state.fullPath + '&contents=' + uploadContents);
            fetch(ReqUploadText);
          }
        }
        break;

      case 'U': // upload local file
        var path;
        if (isMessage) path = this.props.record.what.replace('ivr2:', 'ivr/');
        else path = 'ivr' + this.state.filePath;
        var uploadQ = uploader.methods.getUploads();
        uploadQ.forEach(file => {
          console.log(file);
          if (this.props.record.name!=undefined) {
            uploader.methods.setName (file.id, this.props.record.name);
            file.name = this.props.record.name;
          }
          if (sessionStorage.AllFiles.indexOf('/' + file.name) > -1 && file.status === 'submitted' && !this.state.autoNumbering) {
            if (window.confirm(' קיים קובץ עם שם זהה בתקיה. האם לדרוס את הקובץ ' + file.name)) {
              var filter = JSON.parse(sessionStorage.Filter);
              var deletePath = (filter.path === "/") ? "ivr2:/" + file.name : filter.path + "/" + file.name;

              const ReqDelete = new Request(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=delete&what=' + deletePath);
              fetch(ReqDelete);
            }
            else {
              uploader.methods._handler.cancel(
                file.id);
            }
          }
        });
        uploader.methods.setParams({ uploader: 'yemot-admin', token: sessionStorage.B.encodeDecode(), path: path, convertAudio: 0, autoNumbering: this.state.autoNumbering });
        uploader.methods.uploadStoredFiles();
        this.setState({ showUploadButton: false, showCancelUploadButton: true });

        break;

      case 'R': // record and save audio file

        if ((this.state.fileName === undefined || this.state.fileName === '') && !this.state.autoNumbering && !this.props.isMessage) {
          alert(this.props.translate('trans.noname'))
        }
        else if (sessionStorage.AllFiles.indexOf('/' + fileName) > -1 && !this.state.autoNumbering) {
          if (window.confirm(' קיים קובץ עם שם זהה בתקיה. האם לדרוס את הקובץ ' + fileName)) {
            const ReqDelete = new Request(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=delete&what=ivr2:' + this.state.fullPath);
            fetch(ReqDelete)
              .then(response => response.json())
              .then(response => {
                if (response.responseStatus === 'OK') {
                  var data = new FormData();
                  data.append("upload", this.state.newRecording);
                  data.append("token", sessionStorage.B.encodeDecode());
                  // data.append("convertAudio", '1');

                  if (this.state.autoNumbering) {
                    data.append("path", 'ivr' + this.state.filePath);
                  }
                  else if (isMessage) data.append("path", this.props.record.what.replace('ivr2:', 'ivr/'));
                  else data.append("path", 'ivr' + this.state.fullPath);

                  config = {
                    cancelToken: this.state.source.token,
                    onUploadProgress: function (progressEvent) {
                      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                      this.setState({ recordingUploadProgress: percentCompleted });
                    }.bind(this)
                  };
                  self = this;
                  axios.post(configAPI.api.prod + 'UploadFile', data, config)
                    .then(function (resp) {
                      if (resp.data.responseStatus === 'OK') {
                        self.setState({ startUpload: false });
                      }
                      const { refreshView } = this.props;
                      refreshView();
                    })
                    .catch(function (err) {
                    });
                }
              })
          }
        }
        else {
          var data = new FormData();
          data.append("upload", this.state.newRecording);
          data.append("token", sessionStorage.B.encodeDecode());
          data.append("convertAudio", '1');

          if (this.state.autoNumbering) {
            data.append("path", 'ivr' + this.state.filePath);
          }
          else if (isMessage) data.append("path", this.props.record.what.replace('ivr2:', 'ivr/'));
          else data.append("path", 'ivr' + this.state.fullPath);

          config = {
            cancelToken: this.state.source.token,
            onUploadProgress: function (progressEvent) {
              var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              this.setState({ recordingUploadProgress: percentCompleted });
            }.bind(this)
          };
          self = this;
          axios.post(configAPI.api.prod + 'UploadFile', data, config)
            .then(function (resp) {
              if (resp.data.responseStatus === 'OK') {
                self.setState({ startUpload: false });
              }
              const { refreshView } = this.props;
              refreshView();
            })
            .catch(function (err) {
            });
        }
        break;
      default:
        break;
    }
    this.setState({ showUploadButton: false, approveDelete: false });
    const { refreshView } = this.props;
    refreshView();
  }

  componentDidMount() {
    this.setState({ messageType: sessionStorage.getItem('messageType') })
    if (this.props.isMessage) this.setState({ showUploadButton: true });
    uploader.on('onAllComplete', () => {
      this.setState({ showNewUploadButton: true, showCancelUploadButton: false, startUpload: false });
    })
    uploader.on('statusChange', (id, oldStatus, newStatus) => {
      switch (newStatus) {
        case 'submitted':
          this.setState({ showUploadButton: true, resetUploader: false, showNewUploadButton: true });
          break;
        case 'canceled':
          var fileQ = uploader.methods.getUploads();
          var fileCounter = 0;
          fileQ.forEach(file => {
            if (file.status !== "canceled") fileCounter++;
          });
          if (fileCounter == 0) this.setState({ showUploadButton: false, showCancelUploadButton: false, showNewUploadButton: false });
          break;
        case 'onAllComplete':
        // this.setState({showCancelUploadButton:false, showNewUploadButton:true});
          break;
        default:
          break;
      }
    })
  }

  render() {
    const { translate, classes, isMessage } = this.props;

    return (
      <Tooltip title={translate(`trans.uploadfile`)}>
        <IconButton
          onClick={(e) => this.handleClickOpen(e)}
        >
          <FileUpload />
          <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={this.state.openDialog}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            onBackdropClick={(e) => e.stopPropagation()}
            disableBackdropClick={true}
          >
            <IconButton color="inherit" onClick={(e) => this.handleClose(e)}
              aria-label="Close" style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
            <DialogActions>
              {(this.state.showUploadButton) && (<Button onClick={(e) => this.handleSendSubmit(e, false)} color="primary" variant="contained">
                {translate('ra.action.upload')}
                <CloudUpload />
              </Button>)}
              {(this.state.showCancelUploadButton) && (<Button onClick={(e) => this.CancelUpload(e)} color="secondary" variant="contained">
                {translate('ra.action.cancelUpload')}
                <CancelUpload />
              </Button>)}
              {(this.state.showNewUploadButton) && (<Button onClick={(e) => this.newUpload(e)} color="secondary" variant="contained">
                {translate('ra.action.newUpload')}
                <ClearAll />
              </Button>)}
            </DialogActions>
            <SimpleForm
              toolbar={false}
              defaultValue={{ average_note: 0 }}
              validate={validate}
            >
              <SelectInput source="message_type" label="trans.file_format" choices={[
                (!isMessage) && { id: 'I', name: translate('trans.TEXTINI') },
                { id: 'T', name: translate('trans.TEXTTTS') },
                { id: 'U', name: translate('trans.UPLOAD') },
                { id: 'R', name: translate('trans.RECORDING') },
              ]} onChange={(e) => this.handleMessageTypeChange(e)} onClick={(e) => e.stopPropagation()} value={this.state.messageType} />
              <TextField
                id="filePath"
                // label={this.state.filePathLabel}
                validate={required()} autoFocus
                // helperText={this.state.allowedText}
                // error={this.state.folderPathError}
                value={this.state.fullPath}
                onClick={(e) => e.stopPropagation()}
                margin="normal"
              />

              <FormDataConsumer>

                {/* Text file uploader form: */}
                {({ formData, ...rest }) => (this.state.messageType === 'I' || this.state.messageType === 'T') ?
                  <Fragment>
                    {(!this.props.isMessage) && (<TextInput source="fileName" label="trans.file_name" onChange={this.handleTextFileNameChange}
                      onClick={(e) => e.stopPropagation()} validate={required()} autoFocus />)}
                    <br />
                    <LongTextInput label="trans.write_text"
                      multiline
                      fullWidth="true"
                      rows="15"
                      resetable
                      onChange={this.handleMessageChange} onClick={(e) => e.stopPropagation()} /></Fragment> : <div />
                }
              </FormDataConsumer>
              <FormDataConsumer>

                {/* File uploading form: */}
                {({ formData, ...rest }) => (this.state.messageType === 'U') ?
                  <Fragment>
                    {(this.props.record.name==undefined)&&(<FormControlLabel
                      control={
                        <Checkbox checked={this.state.autoNumbering} onChange={() => this.convertWav(!this.state.autoNumbering)} value={this.state.autoNumbering} />
                      }
                      label={translate('trans.convertToWAV')}
                    />)}
                    <Gallery uploader={uploader} reset={this.state.resetUploader} maxSize={50} />
                  </Fragment> : <div />
                }
              </FormDataConsumer>

              {/* Record and upload form: */}
              <FormDataConsumer>
                {({ formData, ...rest }) => (this.state.messageType === 'R') ?
                  <div>
                    <ReactMic
                      width = '800'
                      record={this.state.record}
                      pause={this.state.pause}
                      className="sound-wave"
                      onStop={this.onStop}
                      onData={this.onData}
                      strokeColor={'#007aff'}
                      mimeType="audio/mp3"
                    // backgroundColor={'#ffff4d'}
                    />
                    <div id="waveform"></div>
                    <div id="timeline"></div>
                    {(this.state.showWave)&&(<div class="col-sm-3">
                      <ZoomOut style={{ float: "left" }} />
                      <input data-action="zoom" type="range" min="0" max="10000" style={{ width: '90%', float: 'center' }} />
                      <ZoomIn style={{ float: "right" }} />
                    </div>)}
                    {(<Button style={{margin: '10px', visibility:this.state.showCrop?'visible':'hidden'}} color="primary" variant="contained" data-action="crop">{translate('trans.crop')}</Button>)}
                    {(<Button style={{margin: '10px',visibility:this.state.showCrop?'visible':'hidden'}} color="primary" variant="contained" data-action="play-region">{translate('trans.playRegion')}</Button>)}
                    {/* <button data-action="delete">delete</button>
                    <button data-action="play">play</button> */}
                    {
                      <FormGroup row>
                        {(this.state.record) ? (
                          <Button variant="fab" color="secondary" aria-label="Stop" className={classes.button}
                            onClick={(e) => this.stopRecording(e)}>
                            <StopIcon />
                          </Button>) : (<Button variant="fab" aria-label="Record" className={classes.button} style={{ backgroundColor: '#cc0000' }}
                            onClick={(e) => this.startRecording(e)}>
                            <MicIcon style={{ fill: "white" }} />
                          </Button>)}
                        {(!isMessage && this.props.record.what === undefined) && (<FormControlLabel
                          control={
                            <Checkbox checked={this.state.autoNumbering} onChange={() => this.convertWav(!this.state.autoNumbering)} value={this.state.autoNumbering} />
                          }
                          label={translate('trans.convertToWAV')}
                        />)}
                        {(!this.state.autoNumbering && !isMessage && this.props.record.what === undefined) && (<TextInput source="fileName" label="trans.file_name"
                          onClick={(e) => e.stopPropagation()} onChange={this.handleTextFileNameChange} validate={required()} autoFocus />)}
                      </FormGroup>}
                    <LinearProgress variant="determinate" value={this.state.recordingUploadProgress} /><span style={{ display: 'table', margin: '0 auto' }}>{this.state.recordingUploadProgress}%</span>
                  </div> : <div />
                }
              </FormDataConsumer>
            </SimpleForm>
            <br></br>
          </Dialog>
        </IconButton >
      </Tooltip>
    );
  }
}

const validate = values => {
  const errors = {};
  ['fileName'].forEach(field => {
    if (!values[field]) {
      errors[field] = ['Required field'];
    }
  });
  if (values.average_note < 0 || values.average_note > 5) {
    errors.average_note = ['Should be between 0 and 5'];
  }
  return errors;
};

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing.unit / 2,
  },
  chip: {
    margin: theme.spacing.unit / 2,
  },
  button: {
    margin: theme.spacing.unit,
  }
});

const enhance = connect(
  null,
  { refreshView: refreshViewAction }
);

export default enhance(connect(null, {
  push: pushAction,
})(withStyles(styles)(translate(UploadFile))));